import React, { useEffect, useContext, useRef } from 'react';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { useLazyDataModel } from '@thd-nucleus/data-sources';

const unique = (value, index, array) => {
  return array.indexOf(value) === index;
};

export const useProducts = ({
  updateLoadedProductsData,
  loadedProductsData,
  setPage,
  projectId
}) => {
  const { deliveryZip } = useContext(ExperienceContext);
  const { storeId } = useStore();
  const itemsBeingFetched = useRef([]);
  const [fetchData, productsResponse] = useLazyDataModel('products', {
    variables: {
      storeId,
      zipCode: deliveryZip,
      projectId
    },
    ssr: false,
    context: { withAuth: true }
  });

  const {
    data: productsInfoData,
    loading: productsInfoLoading,
    error,
    variables: productsVariables
  } = productsResponse || {};

  const isAlreadyLoadedItems = (items) => {
    return items.every((item) => {
      const productKey = item.itemId;
      return loadedProductsData.some((product) => product.itemId === productKey);
    });
  };

  const fetchProducts = async (items) => {
    const filteredItems = items.filter((item) => item.itemType !== 'qc-bridge-catalog-non-shared');
    const itemIdsToFetch = filteredItems.map((filteredItem) => {
      return filteredItem.itemId;
    }).filter(unique);
    const itemsBeingFetchedNow = filteredItems.map((filteredItem) => filteredItem.itemId);
    if (itemIdsToFetch.length === 0) {
      itemsBeingFetched.current = [];
    } else if (isAlreadyLoadedItems(filteredItems)) {
      setPage((prevPage) => prevPage + 1);
    } else if (
      !isAlreadyLoadedItems(filteredItems)
      && itemsBeingFetched.current.join() !== itemsBeingFetchedNow.join()
    ) {
      itemsBeingFetched.current = itemsBeingFetchedNow;
      return fetchData({
        variables: {
          itemIds: itemIdsToFetch
        }
      });
    }
    return null;
  };

  useEffect(() => {
    const { products } = productsInfoData || {};
    if (products?.length || error?.graphQLErrors?.length) {
      const productsData = productsVariables?.itemIds.map((itemId) => {
        const loadedProductData = (products || []).find((product) => product.itemId === itemId) || {};
        return {
          ...loadedProductData,
          itemId,
          price: loadedProductData?.pricing?.value
        };
      });
      if (updateLoadedProductsData) {
        updateLoadedProductsData(productsData);
      }
      setPage((prevPage) => prevPage + 1);
    }
  }, [productsInfoData]);

  return {
    fetchProducts,
    productsInfoData,
    productsInfoLoading,
    error,
    productsVariables
  };
};